<template>
  <v-row>
    <v-col cols="12">
      <div class="inset-fade-effect" :dark="$vuetify.theme.dark" />
      <EcsThemeShowcase />
    </v-col>
  </v-row>
</template>

<script>
import EcsThemeShowcase from '@/components/ecs-theme/EcsThemeShowcase.vue';

export default {
  name: 'EcsSettingsPage',

  components: { EcsThemeShowcase }
};
</script>

<style scoped></style>
